import { QueryClient, QueryCache, type VueQueryPluginOptions } from '@tanstack/vue-query';
import { broadcastQueryClient } from '@tanstack/query-broadcast-client-experimental';
import type { AppError } from '@/modules/common/models/common-error.ts';
import { ErrorUtil } from '@/modules/common/utils/error.util.ts';

const CACHE_TIME = 1000 * 60 * 60 * 12; // 12 hours

export const queryClient = new QueryClient({
  queryCache: new QueryCache({
    onError: (error: AppError) => ErrorUtil.reportError(error),
  }),
  defaultOptions: {
    queries: {
      retry: false,
      staleTime: CACHE_TIME,
      gcTime: CACHE_TIME,
      throwOnError: false,
    },
    mutations: {
      onError: (error: AppError) => ErrorUtil.reportError(error),
    },
  },
});

if (typeof BroadcastChannel === 'function') {
  broadcastQueryClient({
    queryClient,
  });
}

const tanstackQueryOptions: VueQueryPluginOptions = {
  queryClient,
};

export default tanstackQueryOptions;
